
    // Browsers pick a popover's position option when it opens, not when
    // its button scrolls; an open list that no longer fits on screen is
    // reopened so the side with room is picked again.
    export default {
      mounted() {
        this.menu = this.el.querySelector("[popover]")
        this._onViewportChange = (e) => {
          if (this._frame || (e.target instanceof Node && this.menu.contains(e.target))) return
          this._frame = requestAnimationFrame(() => {
            this._frame = null
            this.refit()
          })
        }
        window.addEventListener("scroll", this._onViewportChange, true)
        window.addEventListener("resize", this._onViewportChange)
      },

      refit() {
        if (typeof this.menu.showPopover !== "function" || !this.menu.matches(":popover-open")) return
        const rect = this.menu.getBoundingClientRect()
        if (rect.top >= -1 && rect.bottom <= window.innerHeight + 1) return
        this.menu.hidePopover()
        this.menu.showPopover()
      },

      destroyed() {
        cancelAnimationFrame(this._frame)
        window.removeEventListener("scroll", this._onViewportChange, true)
        window.removeEventListener("resize", this._onViewportChange)
      }
    }
  